import styled from "styled-components";
import { theme } from "../../theme";

const VerticalDivider = styled.span<{ color?: string; height?: string }>`
  width: 1.5px;
  align-self: ${(props) => (props.height ? "center" : "stretch")};
  height: ${(props) => props.height || "auto"};
  background-color: ${(props) => props.color || theme.colors.grey05};
`;

export default VerticalDivider;
